class VariantFilter {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.vfSection;
    this.variants = JSON.parse(root.querySelector('[data-vf-data]').textContent);
    this.mainImage = document.getElementById('MainImage-' + this.sectionId);

    const rawOptions = JSON.parse(root.querySelector('[data-vf-options]').textContent);
    this.optionNames = rawOptions.map(o => (typeof o === 'string' ? o : (o.name || '')));

    this.variants.forEach(v => {
      if (!v.featured_image && v.image) v.featured_image = v.image;
    });

    this.finishIndex = this.detectFinishIndex();
    this.bind();
    this.refresh();
    this.sincronizar();
  }

  detectFinishIndex() {
    for (let i = 0; i < this.optionNames.length; i++) {
      const nome = this.optionNames[i].toLowerCase().trim();
      if (nome.includes('acabamento') || nome.includes('cor') || nome.includes('madeira')) {
        return i;
      }
    }
    return 0;
  }

  getSelection() {
    const sel = [];
    for (let i = 0; i < this.optionNames.length; i++) {
      const grupo = this.grupo(i);
      if (!grupo) { sel.push(null); continue; }
      const marcado = grupo.querySelector('input[type="radio"]:checked');
      sel.push(marcado ? marcado.value : null);
    }
    return sel;
  }

  grupo(i) {
    return this.root.querySelector(`[data-vf-index="${i}"]`);
  }

  marcar(i, valor) {
    const grupo = this.grupo(i);
    if (!grupo) return;
    const input = Array.from(grupo.querySelectorAll('input[type="radio"]'))
      .find(inp => inp.value === valor);
    if (input) input.checked = true;
  }

  resolver(index, valor) {
    const atual = this.getSelection();
    const acabamento = atual[this.finishIndex];

    const candidatas = this.variants.filter(v => v.options[index] === valor);
    if (candidatas.length === 0) return null;

    if (index !== this.finishIndex && acabamento) {
      const mesmoAcabamento = candidatas.filter(
        v => v.options[this.finishIndex] === acabamento
      );
      if (mesmoAcabamento.length > 0) {
        return this.melhorEntre(mesmoAcabamento, atual, index);
      }
    }

    return this.melhorEntre(candidatas, atual, index);
  }

  melhorEntre(lista, selecaoAtual, indexFixo) {
    let melhor = lista[0];
    let melhorPontos = -1;

    lista.forEach(v => {
      let pontos = 0;
      for (let i = 0; i < v.options.length; i++) {
        if (i === indexFixo) continue;
        if (selecaoAtual[i] !== null && v.options[i] === selecaoAtual[i]) {
          pontos += (i === this.finishIndex) ? 10 : 1;
        }
      }
      if (pontos > melhorPontos) {
        melhorPontos = pontos;
        melhor = v;
      }
    });

    return melhor;
  }

  refresh() {
    const selecao = this.getSelection();
    const acabamento = selecao[this.finishIndex];

    for (let i = 0; i < this.optionNames.length; i++) {
      const grupo = this.grupo(i);
      if (!grupo) continue;

      if (i === this.finishIndex) {
        grupo.querySelectorAll('input[type="radio"]').forEach(input => {
          this.exibir(grupo, input, true);
        });
        continue;
      }

      const validos = new Set();
      this.variants.forEach(v => {
        if (!acabamento || v.options[this.finishIndex] === acabamento) {
          validos.add(v.options[i]);
        }
      });

      grupo.querySelectorAll('input[type="radio"]').forEach(input => {
        this.exibir(grupo, input, validos.has(input.value));
      });

      const marcado = grupo.querySelector('input[type="radio"]:checked');
      if (marcado && !validos.has(marcado.value)) {
        const primeiro = Array.from(grupo.querySelectorAll('input[type="radio"]'))
          .find(inp => validos.has(inp.value));
        if (primeiro) primeiro.checked = true;
      }
    }
  }

  exibir(grupo, input, visivel) {
    const label = grupo.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    input.style.display = visivel ? '' : 'none';
    if (label) label.style.display = visivel ? '' : 'none';
  }

  trocarImagem(featuredImage) {
    if (!featuredImage || !this.mainImage) return;
    const src = featuredImage.src || featuredImage;
    this.mainImage.src = src.replace(/(\.[^.?]+)(\?|$)/, '_1200x$1$2');
    if (featuredImage.alt) this.mainImage.alt = featuredImage.alt;
    this.marcarThumb(src);
  }

  marcarThumb(src) {
    const limpar = s => s.split('?')[0].split('/').pop().replace(/_\d+x\d*(\.\w+)$/, '$1');
    const alvo = limpar(src);
    document.querySelectorAll('.custom-gallery__thumb').forEach(thumb => {
      const img = thumb.querySelector('img');
      if (!img) return;
      thumb.classList.toggle('is-active', limpar(img.src) === alvo);
    });
  }

  aplicar(variante) {
    if (!variante) return;

    const campo = this.root.querySelector('[data-vf-variant-id]');
    if (campo) {
      campo.value = variante.id;
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    }

    let img = variante.featured_image;
    if (!img) {
      const irma = this.variants.find(v =>
        v.options[this.finishIndex] === variante.options[this.finishIndex] &&
        v.featured_image
      );
      if (irma) img = irma.featured_image;
    }
    this.trocarImagem(img);

    this.atualizarPreco(variante);
  }

  atualizarPreco(variante) {
    const bloco = document.getElementById('price-' + this.sectionId);
    if (!bloco || typeof variante.price !== 'number') return;

    const formatado = (variante.price / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });

    const alvo = bloco.querySelector('.price-item--regular, .price-item');
    if (alvo) alvo.textContent = formatado;
  }

  sincronizar() {
    const selecao = this.getSelection();
    const exata = this.variants.find(v =>
      v.options.every((opt, i) => opt === selecao[i])
    );
    if (exata) {
      this.aplicar(exata);
      return;
    }
    const parcial = this.variants.find(v =>
      v.options.every((opt, i) => selecao[i] === null || opt === selecao[i])
    );
    if (parcial) this.aplicar(parcial);
  }

  bind() {
    this.root.addEventListener('change', e => {
      if (e.target.type !== 'radio') return;

      const grupo = e.target.closest('[data-vf-index]');
      if (!grupo) return;

      const index = parseInt(grupo.dataset.vfIndex, 10);
      const valor = e.target.value;

      const escolhida = this.resolver(index, valor);
      if (!escolhida) return;

      escolhida.options.forEach((opt, i) => this.marcar(i, opt));

      this.refresh();
      this.aplicar(escolhida);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-vf-section]').forEach(el => {
    try {
      new VariantFilter(el);
    } catch (err) {
      console.error('VariantFilter erro:', err);
    }
  });
});